import type { UnitType } from '~shared/types';
import { getVariantEffect } from '~shared/unit-variants';
import { maxMoveDistance, maxAttackRange, baseDiceCount } from '../scenes/gameLogic';

const TYPE_NAMES: Record<UnitType, string> = {
  infantry:  'Infantry',
  armor:     'Armor',
  artillery: 'Artillery',
};

/** Plain-language rules summary for a unit type (+ optional variant), for the in-game rules dialog. */
export function getUnitRulesSummary(type: UnitType, variant?: string): string {
  const v = getVariantEffect(variant);
  const lines: string[] = [];

  lines.push(v ? `${v.name}  (${TYPE_NAMES[type]})` : TYPE_NAMES[type]);
  lines.push('');
  if (v) { lines.push(v.description); lines.push(''); }

  const moveDist = v?.maxMoveDistance ?? maxMoveDistance(type);
  lines.push(`• Moves up to ${moveDist} hex${moveDist === 1 ? '' : 'es'} per turn`);

  if (type === 'infantry') {
    const limit = v?.canBattleAfterMoveHexes ?? 1;
    lines.push(`• May battle after moving up to ${limit} hex${limit === 1 ? '' : 'es'}`);
  } else if (type === 'armor') {
    lines.push(`• May battle even after moving its full distance`);
  } else {
    lines.push(`• May only battle if it has not moved this turn`);
  }

  lines.push('');
  lines.push('Battle dice by range:');
  const range = maxAttackRange(type);
  for (let dist = 1; dist <= range; dist++) {
    const dice = baseDiceCount(type, dist);
    if (dice > 0) lines.push(`   ${dist} hex${dist === 1 ? '' : 'es'} away — ${dice} ${dice === 1 ? 'die' : 'dice'}`);
  }

  return lines.join('\n');
}
